import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getValueByPath, setValueByPath } from '@guryou/utils';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { ContainedButton } from '../buttons';
import { Block, DefaultText } from '../content';
import { FullScreenSpinner } from '../spinner';
import { serialize } from './utils/formSerializationService';
import validateForm from './utils/formValidationService';
import { FormActions } from './Wrappers';
const parseForm = (form, parserVersion) => {
  if (parserVersion !== 2) {
    return serialize(form, {
      hash: true,
      empty: true
    });
  }
  const values = {};
  Array.from(form.querySelectorAll('input,textarea,select')).forEach(element => {
    if (element.type === 'checkbox' && !element.checked) {
      return;
    }
    let existingValue = getValueByPath(values, element.getAttribute('name'));
    if (!existingValue && existingValue !== 0) {
      setValueByPath(values, element.getAttribute('name'), element.getAttribute('number') === 'true' ? +element.value : element.value);
      return;
    }
    if (!Array.isArray(existingValue)) {
      existingValue = [existingValue];
    }
    setValueByPath(values, element.getAttribute('name'), [...existingValue, element.getAttribute('number') === 'true' ? +element.value : element.value]);
  });
  return values;
};
const LegacyForm = ({
  children,
  onSubmit,
  onChange,
  className,
  actions = null,
  title,
  loading,
  parserVersion,
  enableDebounce
}) => {
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const [form, setForm] = useState();
  const [validationSummaries] = useState([]);
  const [isLoading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const assignFormRef = form => setForm(form);
  const handleSubmit = event => {
    event.preventDefault();
    const data = parseForm(event.target, parserVersion);
    const isFormValid = validateForm(event.target);
    if (onSubmit && isFormValid) {
      onSubmit(data);
    }
  };
  const handleChange = () => {
    if (!onChange) {
      return;
    }
    const onChangeMethod = () => {
      const data = parseForm(form, parserVersion);
      onChange(data);
    };
    if (!enableDebounce) {
      onChangeMethod();
      return;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const id = setTimeout(() => onChangeMethod(), 500);
    setTimeoutId(id);
  };
  let renderActions = actions !== false && actions;
  if (actions === null) {
    renderActions = /*#__PURE__*/React.createElement(FormActions, null, onSubmit && /*#__PURE__*/React.createElement(ContainedButton, {
      marginLeft: "auto",
      marginRight: "auto",
      type: "submit",
      loading: loading,
      text: t('GENERAL.save')
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading && /*#__PURE__*/React.createElement(FullScreenSpinner, null), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    onChange: handleChange,
    ref: assignFormRef
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: className
  }, !!validationSummaries?.length && /*#__PURE__*/React.createElement(Block, {
    marginLeft: 6,
    marginRight: 6
  }, validationSummaries.map(m => /*#__PURE__*/React.createElement(DefaultText, {
    color: theme.palette.error.main
  }, m))), children), renderActions));
};
LegacyForm.propTypes = {
  children: PropTypes.any,
  onSubmit: PropTypes.func,
  onSkip: PropTypes.func,
  className: PropTypes.string,
  actions: PropTypes.any,
  loading: PropTypes.bool,
  saveText: PropTypes.string
};
export default LegacyForm;